import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/site/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Pagina non trovata" />
      <section className="min-h-[70vh] bg-av-black grain flex items-center">
        <div className="relative z-10 mx-auto max-w-2xl px-5 sm:px-8 text-center py-32">
          <p className="overline text-av-bright mb-5">Errore 404</p>
          <h1 className="font-display text-6xl sm:text-7xl text-av-white">Pagina non trovata</h1>
          <p className="mt-6 text-av-gray">La pagina che stai cercando non esiste o è stata spostata.</p>
          <Link to="/" data-testid="notfound-home-link" className="mt-9 inline-flex items-center gap-2 rounded-full bg-av-bright text-av-black px-7 py-3.5 text-sm font-semibold hover:bg-av-lime transition-colors">
            <ArrowLeft size={16} /> Torna alla home
          </Link>
        </div>
      </section>
    </>
  );
}
